/**
 * Custom module layout route — /m/$moduleKey/*
 *
 * Wraps the outlet in the shared app Layout chrome. App-wide providers
 * (modules, theme, sidebar, etc.) are mounted once at `__root.tsx`, so
 * navigating between /m/<a> and /m/<b> doesn't remount the provider tree.
 *
 * We intentionally do NOT gate on requireModule here — custom modules
 * are loaded from the tenant DB per request by the backend, and the
 * user's ability to see them is enforced on every API call via
 * customModuleProcedure's RBAC middleware. If the module doesn't
 * exist, the child routes will surface that as a NOT_FOUND error.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/layout'

export const Route = createFileRoute('/m/$moduleKey')({
  component: CustomModuleLayout,
})

function CustomModuleLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
